export const decimalFormatter = new Intl.NumberFormat(undefined, {
  style: "decimal",
});
